import React, {useEffect} from "react";

const JoinNiceModuleFail = () => {

    useEffect(() => {
        console.log('fail page!');
        let params = new URLSearchParams(window.location.search);
        let errorMsg = params.get('sMessage');
        if (errorMsg === 'decodeSystemError') alert('복호화 시스템 오류입니다.');
        else if (errorMsg === 'decodeError') alert('복호화 처리 오류입니다.');
        else if (errorMsg === 'decodeHashError') alert('복호화 해쉬 오류입니다.');
        else if (errorMsg === 'decodeDataError') alert('복호화 데이터 오류입니다.');
        else if (errorMsg === 'inputDataError') alert('입력 데이터 오류입니다.');
        else if (errorMsg === 'sitePasswordError') alert('사이트 패스워드 오류입니다.');
        else alert(errorMsg);
        window.opener.postMessage("error");
        window.close();
    });

    return (
        <div className={'no-show'}>
            <p/><p/><p/><p/>
            본인인증이 실패하였습니다.<br/><br/>
        </div>
    );
};

export default JoinNiceModuleFail;
